export default __webpack_public_path__ + "static/media/Comfortaa-Bold.d08cb6c0.ttf";